import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import NewsletterHistoryStatusChip from "./NewsletterHistoryStatusChip";

const NewsletterHistoryHtmlPreview = ({ subject, status, htmlSnapshot, showHeader = true }) => (
  <Box>
    {showHeader ? (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2, flexWrap: "wrap" }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, flex: 1, minWidth: 0 }}>
          {subject}
        </Typography>
        <NewsletterHistoryStatusChip status={status} />
      </Box>
    ) : null}
    <Box
      component="iframe"
      title="Anteprima newsletter"
      sandbox=""
      srcDoc={htmlSnapshot || "<p>Nessun contenuto HTML</p>"}
      sx={{
        width: "100%",
        minHeight: 580,
        border: "1px solid #e2e8f0",
        borderRadius: 1,
        bgcolor: "#fff",
      }}
    />
  </Box>
);

NewsletterHistoryHtmlPreview.propTypes = {
  subject: PropTypes.string,
  status: PropTypes.string,
  htmlSnapshot: PropTypes.string,
  showHeader: PropTypes.bool,
};

export default NewsletterHistoryHtmlPreview;
